import { Injectable, signal } from '@angular/core';

interface Preview {
  url: string | null;
  type: PreviewType | null;
}

type PreviewType = 'image' | 'pdf' | null;

@Injectable({
  providedIn: 'root',
})
export class PreviewService {
  private readonly _preview = signal<Preview | null>(null);

  public readonly preview = this._preview.asReadonly();

  public open(blob: Blob): void {
    const url = URL.createObjectURL(blob);

    let type: PreviewType;

    if (blob.type.includes('image')) {
      type = 'image';
    } else if (blob.type.includes('pdf')) {
      type = 'pdf';
    } else {
      type = null;
    }

    this.setPreview({ url, type });
  }

  public setPreview(preview: Preview): void {
    this._preview.set(preview);
  }

  public deletePreview(): void {
    this._preview.set(null);
  }
}
